import React from 'react';
import QnaPage from './qna/index';

const QASessions = () => {
  return <QnaPage />;
};

export default QASessions;